import { ChangeDetectionStrategy, Component, inject, input, output } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDialog } from '@angular/material/dialog';
import { MatExpansionModule } from '@angular/material/expansion';
import { ProductDynamicFormDialogComponent } from '../product-dynamic-form-dialog/product-dynamic-form-dialog.component';
import { filter } from 'rxjs';
import { DialogResultOutput, ProductOrganizationDialogConfig } from '../../product.model';

@Component({
	selector: 'app-product-expansion-panel-template',
	standalone: true,
	imports: [MatExpansionModule, MatButtonModule],
	template: `<mat-expansion-panel>
		<mat-expansion-panel-header>
			<mat-panel-title>
				<div style="width: 250px">{{ panelTitle() }}</div>
				<button (click)="openAddDialog($event)" class="ms-3" color="primary" mat-raised-button>
					Dodaj
					<i class="fa-solid fa-plus"></i></button
			></mat-panel-title>
		</mat-expansion-panel-header>
		<ng-content></ng-content>
	</mat-expansion-panel>`,
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ProductExpansionPanelTemplateComponent {
	readonly panelTitle = input.required<string>();
	readonly addDialogConfig = input.required<ProductOrganizationDialogConfig>();

	readonly emitDialogResult = output<DialogResultOutput>();

	private readonly matDialog = inject(MatDialog);

	openAddDialog(ev: MouseEvent): void {
		ev.stopPropagation();
		this.matDialog
			.open(ProductDynamicFormDialogComponent, {
				data: this.addDialogConfig(),
				width: '520px',
				autoFocus: true,
				restoreFocus: true,
				disableClose: true,
			})
			.afterClosed()
			.pipe(filter(Boolean))
			.subscribe((result) => {
				this.emitDialogResult.emit(result);
			});
	}
}
